// Set when the API rejects the current token mid-session, so the login page
// can explain why the user was sent there.
const SESSION_EXPIRED_KEY = 'mercury_session_expired';

export const SESSION_EXPIRED_MESSAGE = 'Your session has expired. Please log in again.';

export function markSessionExpired() {
  try {
    sessionStorage.setItem(SESSION_EXPIRED_KEY, 'true');
  } catch {
    // Storage can be unavailable (private mode); the notice is best-effort.
  }
}

export function isSessionExpired() {
  try {
    return sessionStorage.getItem(SESSION_EXPIRED_KEY) === 'true';
  } catch {
    return false;
  }
}

export function clearSessionExpired() {
  try {
    sessionStorage.removeItem(SESSION_EXPIRED_KEY);
  } catch {
    // ignore
  }
}
